// ui
// actions
import { StateChange } from "../../../actions/page.actions";

// selectors
import { getPageName } from "../../../selectors/navigation";

import ui from "./ui";

/**
 * Will update the page state.
 *
 * @param {Array} keyPath - key path of the ui value
 * @param {any} value - next value of the given key path
 */
export const updateUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);

	dispatch(StateChange(pageName, keyPath, value));
};

/**
 * Initializes the UI.
 * If there is an `assignee` in the query params, set that as the initial
 * assignee.
 * */
export const initialize = () => async (dispatch) => {
	// 1 - load in the initial state
	const initialState = ui;

	// 2 - update our state with the initial ui
	dispatch(updateUI([], initialState));
};
